import { inject, Injectable } from '@angular/core'
import { NavController } from '@ionic/angular'

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private navCtrl = inject(NavController)

  async goToAssistantProfile(assistantId: number, section = 'basic-info') {
    await this.navCtrl.navigateForward(`/menu/app/tabs/workers/assistant/${assistantId}/${section}`)
  }

  async goToSrWorkerProfile(workerId: number, section = 'basic-info') {
    await this.navCtrl.navigateForward(`/menu/app/tabs/workers/sr-worker/${workerId}/${section}`)
  }

  async goToClientProfile(clientId: number, section = 'basic-info') {
    await this.navCtrl.navigateForward(`/menu/app/tabs/clients/client/${clientId}/${section}`)
  }

  async goToLogin() {
    await this.navCtrl.navigateRoot('/login')
  }
}
